import { Entity } from '@adornis/baseql/decorators.js';
import { FormOfFinancing } from './FormOfFinancing.js';

/**
 * @entity FormOfFinancingMitgliedsbeitrag
 */
@Entity()
export class FormOfFinancingMitgliedsbeitrag extends FormOfFinancing {
  public static override _class = 'FormOfFinancingMitgliedsbeitrag';
}
